import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Input,
  UncontrolledTooltip,
  FormGroup,
  Label
} from "reactstrap";
import { Link } from "react-router-dom";
import PaginationComponent from "components/Custom/Pagination";
// import ReactBSAlert from "react-bootstrap-sweetalert";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import { getClientsRequest, deleteClientRequest } from 'api/client';
import { calcStartEndPage } from 'helpers/pagination';
import { formatPrice } from "helpers/pricing";
import { formatClientStatus } from "helpers/status";
import { hasPermission } from "helpers/auth";
import ProjectContext from "contexts/ProjectContext";

class Clients extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          clients: null,
          alert: null,
          total: 0,
          pages: 0,
          current_page: 0,
          start_page: 0,
          end_page: 9,
          first_page: 0,
          last_page: 0,
          deleteClientId: '',
          filters: { limit: 25, page: 0,},
          loading: true
        }
        this.timeout = null;
    }
    static contextType = ProjectContext;


    async componentDidMount() {
        this.previousContext = this.context;
        const { selectedProject } = this.context

        if(selectedProject) await this.getClients()
    }

    async componentDidUpdate(prevProps, prevState) {
		if(this.previousContext.selectedProject !== this.context.selectedProject) {
			this.previousContext.selectedProject = this.context.selectedProject
			await this.getClients()
		}
    }

    getClients = async () => {
        this.setState({loading: true})
        const { filters } = this.state;
        const { selectedProject } = this.context

		filters.project = selectedProject

        const clientsObj = await getClientsRequest(filters);
        const clients = clientsObj.clients;
        const total = clientsObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            clients,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    }
  
    goTo = path => this.props.history.push(path);

    goToPage = async (page) => {
        const { filters, pages } = this.state;
        const clientsObj = await getClientsRequest({...filters, page});
        const clients = clientsObj.clients;
        const { start_page, end_page } = calcStartEndPage(page, pages);

        this.setState({
            clients: clients,
            current_page: page,
            start_page: start_page,
            end_page: end_page
        })
    }

    /*hideAlert = () => {
        this.setState({
          alert: null
        });
    };*/

    /*showConfirmDeleteAlert = (id) => {
        this.setState({
            alert: (
              <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => this.deleteClient(id)}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
                btnSize=""
              >
                The client will be deleted permanently
              </ReactBSAlert>
            )
        });
    }*/

    /*deleteClient = async (id) => {
        
    }*/

    onChangeFilter = (event) => {
        const { filters } = this.state;
		const { value, name } = event.target;
		this.setState({
			filters: {...filters, [name]: value, page:0},
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getClients();
		}, 300);
    }

    openConfirmation = (clientId) => () => {
		this.setState({
			deleteClientId: clientId
		});
		this.deleteConfirmationModal.toggle();
    }
    
    deleteClient = async () => {
		const { deleteClientId } = this.state;
        await deleteClientRequest(deleteClientId);
        this.getClients()
	}

    render() {

        const {
            clients,
            alert,
            pages,
            current_page,
            start_page,
            end_page,
            search, 
            loading
        } = this.state;
        return (
            <>
            <div className="content">
            {alert}
            <Row>
                <Col md="12">
                <Card>
                    <CardHeader>
                        <CardTitle className="d-inline-block" tag="h4">
                            Clients
                        </CardTitle>
                        <FormGroup>
                            <Label>Client</Label>
                            <Input placeholder="Search Clients..." value={search} name="search" type="text" onChange={this.onChangeFilter}></Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Client</Label>
                            <Input name="status" value={search} type="select" onChange={this.onChangeFilter}>
                                <option value="">Select Status</option>
                                <option value="available">Available</option>
                                <option value="reserved">Reserved</option>
                                <option value="active">Active</option>
                                <option value="fullyPaid">Fully Paid</option>
                                <option value="completed">Completed</option>
                                <option value="canceled">Canceled</option>
                            </Input>
                        </FormGroup>
                        {hasPermission('CreateClient') ? <Button className="pull-right mb-3 add-btn" color="primary" onClick={() => this.goTo('/client/create')}><i className="tim-icons icon-simple-add" /> Client</Button> : null}
                    </CardHeader>
                    <CardBody>
                    <Table responsive>
                        <thead className="text-primary">
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Unit</th>
                            <th>Model</th>
                            <th>TCP</th>
                            <th className="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            loading ?    
                            <tr>
                                <td colSpan={10}>Loading...</td>
                            </tr>
                            :
                            clients && clients.length
                            ? clients.map((client) => {
                                return (
                                    <tr key={client._id}>
                                        <td>{client.first_name} {client.last_name}</td>
                                        <td>{client.status ? formatClientStatus(client.status) : "N/A"}</td>
                                        <td>{client.unit
                                            ? <Link to={`/unit?id=${client.unit._id}`}>{`Block ${client.unit.block_number} Unit ${client.unit.lot_number}`}</Link>
                                            : "N/A"
                                        }</td>
                                        <td>{client.unit?.selectedModel ? `${client.unit.selectedModel.name}` : "N/A"}</td>
                                        <td>{client.unit?.selectedModel?.tcp ? `${formatPrice(client.unit.selectedModel.tcp)}` : "N/A"}</td>
                                        <td className="text-right">
                                            <Button
                                                className="btn-link btn-icon"
                                                color="success"
                                                id={`tooltip-view-${client._id}`}
                                                size="sm"
                                                onClick={() => this.goTo(`/client?id=${client._id}`)}
                                            >
                                                <i className="tim-icons icon-zoom-split" />
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                target={`tooltip-view-${client._id}`}
                                            >
                                                View
                                            </UncontrolledTooltip>
                                            {hasPermission('EditClient') ? <>
                                                <Button
                                                    className="btn-link btn-icon"
                                                    color="info"
                                                    id={`tooltip-edit-${client._id}`}
                                                    size="sm"
                                                    onClick={() => this.goTo(`/client/edit?id=${client._id}`)}
                                                >
                                                    <i className="tim-icons icon-pencil" />
                                                </Button>
                                                <UncontrolledTooltip
                                                    delay={0}
                                                    target={`tooltip-edit-${client._id}`}
                                                >
                                                    Edit
                                                </UncontrolledTooltip>
                                                <Button
                                                    className="btn-link btn-icon"
                                                    color="danger"
                                                    id={`tooltip-delete-${client._id}`}
                                                    size="sm"
                                                    onClick={this.openConfirmation(client._id)}
                                                >
                                                    <i className="tim-icons icon-simple-remove" />
                                                </Button>
                                                <UncontrolledTooltip
                                                    delay={0}
                                                    target={`tooltip-delete-${client._id}`}
                                                >
                                                    Delete
                                                </UncontrolledTooltip>
                                            </> : null}
                                        </td>
                                    </tr>
                                )
                            })
                            :   <tr>
                                    <td colSpan="6">There's no client to show</td>
                                </tr>
                        }
                        
                        </tbody>
                    </Table>
                    {clients?.length > 0 && 
                        <PaginationComponent 
                            pages={pages}
                            current_page={current_page}
                            start_page={start_page}
                            end_page={end_page}
                            goToPage={this.goToPage}
                        />
                    }
                    </CardBody>
                </Card>
                </Col>
            </Row>
            <ConfirmationModal
                ref={el => this.deleteConfirmationModal = el}
                title="Delete Client?"
                buttons={[
                    { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                    { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteClient }
                ]}
            >
                Are you sure you want to delete this client?
            </ConfirmationModal>
            </div>
        </>
        );
    }
}

export default Clients;
